import { useState } from 'react';

export function ApiOutputItemNumberInput({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number) => void;
}) {
  const [inputValue, setInputValue] = useState<string>(String(value));
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(raw)) {
      setInputValue(raw);
      onChange(raw === '' || raw === '.' ? 0 : Number(raw));
    }
  };

  return (
    <input
      pattern='[0-9]*\.?[0-9]*'
      className='m-0 h-auto w-full border-b !border-gray-300 bg-transparent px-2 py-1'
      value={inputValue}
      onChange={handleChange}
    />
  );
}
